module.exports = __webpack_public_path__ + "static/media/VALAS.1340b1ed.svg";